// AUTO GENERATED FILE - DO NOT EDIT
export default {
  analytics_onboarding_call_type_link: 'link',
  analytics_onboarding_call_type_view: 'view',
  analytics_onboarding_congratulations_screen: 'Congratulations screen',
  analytics_onboarding_event_action_click: 'OnClick',
  analytics_onboarding_event_action_key: 'event_action',
  analytics_onboarding_event_category: 'Button',
  analytics_onboarding_event_category_key: 'event_category',
  analytics_onboarding_event_label_key: 'event_label',
  analytics_onboarding_event_section_home: 'home',
  analytics_onboarding_journey_type: 'Onboarding',
  analytics_onboarding_journey_type_key: 'journey_type',
  analytics_onboarding_page_name: 'Onboarding home',
  analytics_onboarding_page_name_key: 'page_name',
  analytics_onboarding_page_section: 'Onboarding; %1$s',
  analytics_onboarding_page_section_home: 'Onboarding; home',
  analytics_onboarding_page_section_key: 'page_section',
  analytics_onboarding_permissions_event_label: 'onboarding',
  analytics_onboarding_permissions_scrolled: 'Permissions (scrolled)',
  analytics_onboarding_visitor_permission_functional_key: 'visitor_permission_functional',
  analytics_onboarding_visitor_permission_name_key: 'visitor_permission_name',
  analytics_onboarding_visitor_permission_performance_key: 'visitor_permission_performance',
  analytics_onboarding_visitor_permission_targeting_enabled: 'enabled',
  analytics_onboarding_visitor_permission_targeting_key: 'visitor_permission_targeting',
  analytics_onboarding_visitor_permissions_key: 'visitor_permissions',
  onboarding_congratulations_sub_title: 'It\'s all set and ready to go.',
  onboarding_congratulations_title: 'Congratulations!',
  onboarding_continue_label: 'Get started',
  onboarding_getting_started_label: 'Getting started',
  onboarding_greeting_text: 'Hi %1$s,',
  onboarding_screens_title: 'My Vodafone',
  onboarding_start_action_label: 'Let\'s go!',
  onboarding_welcome_text: 'Welcome to My Vodafone. Let\'s start setting up your account.',
  permissions_button_title: 'I am happy with this',
  permissions_header_title: 'You can change these from your Settings screen later.',
  permissions_step_title: 'Permissions for improved experience',
  privacy_policy_hyperlink_text: 'privacy policy',
  terms_and_conditions_agree_title: 'I agree',
  terms_and_conditions_continue_annoncement: 'you will continue to onboarding',
  terms_and_conditions_continue_button: 'Continue',
  terms_and_conditions_description_text: 'By using the app you agree to our %1$s and confirm you have read and understood our %2$s.',
  terms_and_conditions_hyperlink_text: 'Terms and conditions',
  terms_and_conditions_quick_action_title: 'Terms & conditions and privacy policy',
  terms_and_conditions_selected_agreement: 'Double tap if you want to select the agreement of terms and condition',
  terms_and_conditions_unselected_agreement: 'Double tap if you want to unSelect the agreement of terms and condition'
}
